import styled from "styled-components";
import { Row } from "@viagogo/core/ui";
import { ExploreEvents } from "src/website-apps/shared/components/explore-events";

export const VerticalMarginRow = styled(Row)`
  margin-top: ${(props) => props.theme.spacing(36)};
  margin-bottom: ${(props) => props.theme.spacing(18)};
`;

export const VerticalMarginTopRow = styled(Row)`
  margin-top: ${(props) => props.theme.spacing(8)};
`;

export const StyledExploreOnCity = styled(ExploreEvents)`
  margin-bottom: ${({ theme }) => theme.spacing(4)};

  @media ${({ theme: { media } }) => `${media.tablet}, ${media.desktop}`} {
    margin-bottom: ${({ theme }) => theme.spacing(6)};
  }
`;
